import React, { useEffect, useState } from "react";
import axios from 'axios';

import { Auth } from 'aws-amplify';
import awsconfig from '../bws-exports';

var path = window.location.href;
if (path.includes("?")) {
    path = window.location.href.slice(0, window.location.href.lastIndexOf('?'));
    console.log(path);
}
if(path.includes("#")) {
    path = window.location.href.slice(0, window.location.href.lastIndexOf('#'));

}
awsconfig.oauth.redirectSignIn = path;




function Livefeed() {
    const [feed, setfeed] = useState({});

    useEffect(() => {

        var isauth = false;

        Auth.currentAuthenticatedUser({
            bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        })
            .then((user) => {
                console.log(user);
                isauth = true;

                axios.get('https://76hwbexd1g.execute-api.us-east-1.amazonaws.com/prod')
                    .then(response => {

                        setfeed(response.data.body);


                    });

            }).catch((err) => {
                console.log(err);
                if (!isauth) {
                    Auth.federatedSignIn({ customProvider: "Gallo" });
                }
            })


    }, []);
    if (!feed) return null;
    if (!Array.isArray(feed)) return null;
    return (
        <div><h1>Live Feed!</h1>
            <ul>
                {feed.map(data => (
                    <li key={data.UserName + data.Booth}>{data.Name} visited {data.BoothName}</li>
                ))}
            </ul>
        </div>
    );
}



export default Livefeed;

